module.exports = __webpack_public_path__ + "img/bg-footer.78a28dae.png";